// Download do app Android (APK) — /app-celular/versao e /app-celular/download (sem login) e o envio da versão nova pelo
// Admin (/configuracoes/app-celular/apk). Ver MobileAppReleaseCommands.cs.
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export interface AppRelease {
  version: string
  sizeBytes: number
  uploadedAt: string
  notes: string | null
}

/** A versão disponível pra baixar; nulo se nenhuma foi enviada (ou sem conexão). */
export async function getAppRelease(): Promise<AppRelease | null> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}/app-celular/versao`)
    return res.status === 200 ? await res.json() : null
  } catch {
    return null
  }
}

/** Endereço completo do download (o app abre no navegador do celular, fora do WebView). */
export function appDownloadUrl(): string {
  return new URL(`${WOOTDASH_BASE}/app-celular/download`, window.location.origin).href
}

/** "6,1 MB" */
export function formatAppSize(bytes: number): string {
  return `${(bytes / (1024 * 1024)).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} MB`
}

/** Admin: publica o APK novo. */
export async function uploadAppRelease(token: string, file: File, version: string, notes: string): Promise<{ release: AppRelease } | { problem: string }> {
  const form = new FormData()
  form.append('arquivo', file)
  form.append('versao', version)
  if (notes.trim()) form.append('novidades', notes.trim())
  try {
    const res = await fetch(`${WOOTDASH_BASE}/configuracoes/app-celular/apk`, { method: 'POST', headers: wootdashAuthHeaders(token), body: form })
    const data = await res.json().catch(() => null)
    if (res.ok && data?.version) return { release: data }
    if (res.status === 413) return { problem: 'O APK passou do tamanho máximo (50 MB).' }
    return { problem: data?.problem ?? `Erro ${res.status} ao enviar o APK.` }
  } catch {
    return { problem: 'Não foi possível falar com o servidor.' }
  }
}
